import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AgroReportCumulation, AgroReportSubvention} from '../models/api/agro/agro-report.model';
import {DateRange} from '../models/api/date-range.model';

@Injectable()
export class AgroReportService {
    cumulationBaseUrl = '/evo/api/agro-cumulation';
    subventionBaseUrl = '/evo/api/agro-subvention';

    constructor(private http: HttpClient) {}

    getCumulationPeriods() {
        return this.http.get<DateRange[]>(`${this.cumulationBaseUrl}/periods`);
    }

    getCumulationReport(date: string) {
        return this.http.get<AgroReportCumulation>(`${this.cumulationBaseUrl}/report/${date}`);
    }

    getSubventionReport(year: number) {
        return this.http.get<AgroReportSubvention>(`${this.subventionBaseUrl}/${year}`);
    }
}
